import { scrubEvent } from "@portal/shared/scrub";
import * as Sentry from "@sentry/nextjs";

// ブラウザ側のエラー監視（ADR-0012）。NEXT_PUBLIC_SENTRY_DSN があるときだけ。画面の録画・性能の計測はしない
if (process.env.NEXT_PUBLIC_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT ?? "production",
    tracesSampleRate: 0,
    initialScope: { tags: { role: "browser" } },
    dataCollection: { userInfo: false, cookies: false, httpHeaders: false, httpBodies: [], urlQueryParams: false, stackFrameVariables: false },
    beforeSend: (e) => scrubEvent(e),
    beforeBreadcrumb: (b) => (b.category === "ui.input" || b.category === "fetch" || b.category === "xhr" || b.category === "console" || b.category === "navigation" ? null : b),
  });
}
